import styled from "styled-components";

export const SectionWrapper = styled.div`
  width: 100%;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  width: 100%;
`;
